import { bootstrap } from './bootstrap';
import { services } from './services';
import { routes } from './routes';
import { controllers } from './controllers';
import { config } from './config';

export default {
  bootstrap,
  services,
  routes,
  controllers,
  config,
};
